import instance from './http'
import api from "./config"

export const  sourceTest = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/henanClue/list', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  sourcePushpage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/henanClue/page', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  sourcePushmissValueFilterInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/henanClue/missValueFilterInfo', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  sourcePushlowConcentrationInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/henanClue/lowConcentrationInfo', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  sourcePushcoOfVariationInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/henanClue/coOfVariationInfo', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  sourcePushexceptionIdentificationInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/henanClue/exceptionIdentificationInfo', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}




export const  sourcePushactOfExtubationInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/henanClue/actOfExtubationInfo', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const  sourcePushconvertOxygeninfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/henanClue/convertOxygeninfo', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  sourcePushstopedInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api.api+'/sourcePush/stopedInfo', {params:params})
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const  sourcePushonlineHourData = params => {
    return new Promise((resolve, reject) => {
        instance.post(api.api+'/henanClue/onlineHourData', params)
            .then(response => {
                if (response){
                    resolve(response.data)
                }else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}
